export enum OutreachChipTypeEnum {
  Regular = 'REGULAR',
  Warning = 'WARNING',
}
